import Modal from '@lyra/core/components/Modal'
import Section from '@lyra/core/components/Section'
import { SelectedInstrument } from '@lyra/web/constants/instruments'
import useOrderQueryParamsForInstrument from '@lyra/web/hooks/useOrderQueryParamsForInstrument'
import useTicker from '@lyra/web/hooks/useTicker'
import { formatInstrumentWithDirection } from '@lyra/web/utils/instruments'
import { useMemo } from 'react'

import TradeForm from './TradeForm'
import TradeFormOrderTypeTabs from './TradeFormOrderTypeTabs'

const EMPTY_SECTION_HEIGHT = 360

type Props = {
  instrumentName: string
  onClose: () => void
  onSubmitOrder?: () => void
}

export default function TradeFormOrderbookModalQueryParams({
  instrumentName,
  onSubmitOrder,
  onClose,
}: Props) {
  const [orderParams, setOrderParams] = useOrderQueryParamsForInstrument(instrumentName)

  const ticker = useTicker(instrumentName)

  const instruments: SelectedInstrument[] = useMemo(
    () => [
      {
        instrument_name: instrumentName,
        direction: orderParams.direction,
      },
    ],
    [instrumentName, orderParams.direction]
  )

  const strategyName = formatInstrumentWithDirection(
    instrumentName,
    orderParams.direction === 'buy',
    {
      showExpiry: true,
    }
  )

  return (
    <Modal title={strategyName} onClose={onClose} desktopWidth={360}>
      <TradeFormOrderTypeTabs
        instruments={instruments}
        orderParams={orderParams}
        setOrderParams={setOrderParams}
        isRfqDisabled
      />
      {ticker ? (
        <TradeForm
          ticker={ticker}
          orderParams={orderParams}
          setOrderParams={setOrderParams}
          onSubmitOrder={onSubmitOrder}
        />
      ) : (
        <Section.Spinner height={EMPTY_SECTION_HEIGHT} />
      )}
    </Modal>
  )
}
